import Vue from 'vue'

// 初始化全局事件总线
window.EVENT_BUS = new Vue()
window.EVENT_BUS.cachePromise = null

// 保存原始 $on 方法
const originalOn = window.EVENT_BUS.$on

// 封装 $on 方法
window.EVENT_BUS.$on = function (eventName, callback) {
    if (typeof callback !== 'function') {
        console.warn(`The callback for event '${eventName}' is not a function.`)
        return
    }

    // 包装回调函数
    const wrappedCallback = function (...args) {
        console.log(`Intercepted event: ${eventName}`, ...args)

        // 特殊处理 loginSuccess 事件
        if (eventName === 'loginSuccess') {
            if (window.EVENT_BUS.cachePromise) {
                console.log('清空登录判断缓存 window.EVENT_BUS.cachePromise')
                window.EVENT_BUS.cachePromise = null // 清空缓存
            }
        }

        // 调用原始回调函数
        callback.apply(this, args)
    }

    // 使用原始 $on 方法注册事件和包装后的回调
    originalOn.call(this, eventName, wrappedCallback)
}
